module.exports = __webpack_public_path__ + "img/user-10.ac448f99.jpg";